import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import VXETable from "vxe-table";
import 'vxe-table/lib/style.css'

import i18n from "@/i18n";
VXETable.setup({
    i18n:(key,args) => i18n.global.t(key, args)
})
function useTable (app) {
    app.use(VXETable)
}

createApp(App).use(i18n).use(useTable).use(router).use(ElementPlus).mount('#app')
